export default __webpack_public_path__ + "static/blob-14-542dcf28da81946bd31f6c12316a5455.svg";